"use strict";
// @ts-ignore
try {
    self['workbox:broadcast-update:5.1.3'] && _();
}
catch (e) { }
